import uploadIsLoading from './uploadIsLoading';
import uploadUrl from './uploadUrl';

const imageSelectors = {
  uploadIsLoading,
  uploadUrl,
};

export default imageSelectors;
